 
import { OurHappyClients } from "../../../../constants";
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import Testimonials from "../../../home/common/Testimonials";
import BestService from "./BestService";
import Counter from "./Counter";

const ServicesContainer = () => {
  return (
    <>
      <Breadcrumbs title="Services" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <BestService />
      <Counter />
      <Testimonials type={"car_demo1"} animation={false} title={OurHappyClients} />
    </>
  );
};

export default ServicesContainer;
